import React, { useState, useContext } from 'react';
import { AuthContext } from '../AuthContext'; // Import for ENS gating

const SafeGuard = () => {
  const { isAuthenticated, ensName, loginWithSIWE } = useContext(AuthContext);
  const [amount, setAmount] = useState('');
  const [lockPeriod, setLockPeriod] = useState(7); // Default 7 days
  const [lockedFunds, setLockedFunds] = useState(0); // Mock locked amount
  const [releaseTime, setReleaseTime] = useState(0); // Mock release timestamp
  const [message, setMessage] = useState(''); // Message state
  const [currency, setCurrency] = useState('USD1'); // Default to USD1

  const deposit = async () => {
    if (!isAuthenticated) {
      alert('Please connect your wallet with a .xbsys.eth domain to use Safe Guard');
      return;
    }
    // Mock contract interaction for deposit - unmock later with ethers or web3.js
    const feeAmount = parseFloat(amount) * 0.005;
    const netAmount = parseFloat(amount) - feeAmount;
    const release = Date.now() + (lockPeriod * 24 * 60 * 60 * 1000); // Milliseconds
    setLockedFunds(netAmount);
    setReleaseTime(release);
    setMessage(`Deposited ${amount} ${currency} to Omnilock. Fee: ${(feeAmount).toFixed(2)} ${currency} → web3reg.eth. Locked for ${lockPeriod} days with BankSystem approval. America First Wealth Secured!`);
  };

  const withdraw = async () => {
    if (!isAuthenticated) {
      alert('Please connect your wallet with a .xbsys.eth domain to use Safe Guard');
      return;
    }
    // Mock contract interaction for withdrawal - unmock later with multi-sig call
    if (Date.now() < releaseTime) {
      setMessage('Funds are time-locked. Request BankSystem approval for early withdrawal.');
      // Placeholder for video call verification request
      alert('Video call verification required for early withdrawal. Contact BankSystem admin.');
      return;
    }
    setMessage(`Withdrawal approved. ${lockedFunds} ${currency} released. Keep America Great!`);
    setLockedFunds(0);
    setReleaseTime(0);
  };

  return (
    <div
      className="safe-guard-container"
      style={{
        backgroundColor: '#1a1a1a',
        color: '#FFFFFF',
        padding: '2rem',
        borderRadius: '10px',
        width: '80%',
        maxWidth: '800px',
        boxShadow: '0 0 20px gold',
        transition: 'box-shadow 0.3s ease',
        margin: '2rem auto',
        textAlign: 'center',
        border: '2px solid #FFD700' // Gold border for Trump vibe
      }}
      onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
      onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
    >
      <h1 style={{ fontSize: '2rem', color: '#FFD700' }}>SafeGuard Storage – Omnilock.eth</h1>
      <p style={{ fontSize: '1.2rem' }}>Secure your USD1 or ETH with maximum deterrence. Time-locked and multi-sig escrow wallet. America First Wealth with BankSystem!</p>
      {/* Dynamic Connection Status */}
      <div className="mb-6" style={{ backgroundColor: '#333', padding: '1rem', borderRadius: '5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="flex items-center space-x-3">
          <div className={`w-3 h-3 rounded-full ${isAuthenticated ? 'bg-green-500' : 'bg-red-500'}`}></div>
          <span className="font-medium" style={{ color: isAuthenticated ? '#00FF00' : '#FF0000' }}>
            {isAuthenticated ? `✓ Wallet Connected: ${ensName || 'Unknown'} (Authenticated)` : 'Not Connected'}
          </span>
        </div>
        {!isAuthenticated && (
          <button
            onClick={loginWithSIWE}
            style={{
              background: 'transparent',
              border: '2px solid #FFD700',
              color: '#FFD700',
              padding: '15px 30px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFD700'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            Connect Wallet
          </button>
        )}
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <label>Amount (USD1 or ETH):</label>
        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="Enter amount to deposit"
          style={{ marginLeft: '1rem', width: '100px', backgroundColor: '#333', color: '#FFF', border: '1px solid #FFD700' }}
        />
        <select
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          style={{ marginLeft: '1rem', padding: '0.3rem', backgroundColor: '#333', color: '#FFF', border: '1px solid #FFD700' }}
        >
          <option value="USD1" style={{ backgroundColor: '#333', color: '#FFD700' }}>USD1</option>
          <option value="ETH" style={{ backgroundColor: '#333', color: '#FFD700' }}>ETH</option>
        </select>
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <label>Lock Period (Days):</label>
        <select value={lockPeriod} onChange={(e) => setLockPeriod(parseInt(e.target.value))} style={{ marginLeft: '1rem', backgroundColor: '#333', color: '#FFF', border: '1px solid #FFD700' }}>
          <option value={7} style={{ backgroundColor: '#333', color: '#FFD700' }}>7 Days</option>
          <option value={14} style={{ backgroundColor: '#333', color: '#FFD700' }}>14 Days</option>
          <option value={30} style={{ backgroundColor: '#333', color: '#FFD700' }}>30 Days</option>
        </select>
      </div>
      <button onClick={deposit} style={{ backgroundColor: '#FFD700', color: '#1a1a1a', padding: '0.5rem 1rem', marginRight: '1rem', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>Deposit</button>
      <button onClick={withdraw} style={{ backgroundColor: '#f44336', color: 'white', padding: '0.5rem 1rem', border: 'none', cursor: 'pointer' }}>Withdraw</button>
      <p style={{ marginTop: '2rem' }}>{message}</p>
      <div style={{ marginTop: '2rem' }}>
        <h2>Your Locked Funds</h2>
        <p>Amount: {lockedFunds} {currency}</p>
        <p>Release Time: {releaseTime ? new Date(releaseTime).toLocaleString() : 'N/A'}</p>
      </div>
      <p className="note" style={{ marginTop: '2rem', fontSize: '0.8rem', color: '#999' }}>Note: This is a mock implementation. Security features like multi-sig, time-locks, and admin approval will be unmocked in the full contract. For now, enjoy the simulation!</p>
    </div>
  );
};
export default SafeGuard;
